import { BaseEntryScope, Hooks } from '#packages/apilib';
import {
  EditorAPIKey,
  MobileBlockReparantingApiKey,
  SlotOpenerApiKey,
  CompPointersApiKey,
} from '#packages/apis';

export class Scope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  slotOpenerApi = this.useDependency(SlotOpenerApiKey);
  mobileBlockReparentingApi = this.useDependency(MobileBlockReparantingApiKey);
  compPointersApi = this.useDependency(CompPointersApiKey);

  hooks = this.declareApi(() => ({
    dragStart: Hooks.createHook(),
    drag: Hooks.createHook<{ position: { x: number; y: number } }>(),
    beforeDragEnd: Hooks.createHook(),
    dragEnd: Hooks.createHook<{ position: { x: number; y: number } }>(),
  }));
}
